import AxiosInstanceCreator from 'services/api';
import { BaseApiResponse } from '../../common';
import { CctvResponse, IotResponse } from '../models/maps.model.ts';

const device = '/device';

const deviceInstance = new AxiosInstanceCreator().create();

export const deviceApi = {
  async getCctvList(): Promise<BaseApiResponse<unknown, CctvResponse>> {
    const response = await deviceInstance.get(`${device}/cctv`);

    return response.data;
  },

  async getIotList(): Promise<BaseApiResponse<unknown, IotResponse>> {
    const response = await deviceInstance.get(`${device}/iot`);

    return response.data;
  }
};
